// @ts-ignore
import snackbarSlice from './snackbarSlice';

export * from './snackbarSlice';

// @ts-ignore
export default snackbarSlice;
